module.exports = __webpack_public_path__ + "img/蜂蜜浏览器_homepage142.69a8fa70.png";